export const MIXPANEL_TOKEN =
  process.env.REACT_APP_MIXPANEL_TOKEN || '42821504cda206cd0c4716695cb669de';
export const GALACTICA_BACKEND =
  process.env.REACT_APP_GALACTICA_BACKEND !== undefined
    ? process.env.REACT_APP_GALACTICA_BACKEND
    : 'http://localhost:2001';
export const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  'https://4d2cda209a85422a852467120e95a503@o124058.ingest.sentry.io/5606883';
export const UNLEASH_FLAG_PROVIDER_API_TOKEN =
  '*:default.2b1d2c87022af6b1469024aa5dc3f95207caab17a67e06de55a1eab3';

export const DATA_VALIDATION_SERVICE_URL = `${GALACTICA_BACKEND}/api/jobs`;
export const CONSISTENCY_JOBS_URL = `${GALACTICA_BACKEND}/api/consistency-jobs`;
export const CONSISTENCY_FAILED_INSTANCES_URL = (runStatusId: string): string =>
  `${GALACTICA_BACKEND}/api/consistency-jobs/${runStatusId}/failed-instances`;

// Documentation (Docusaurus)
const hostDocs =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3003' : '';

export const URL_DOCS = `${hostDocs}/docs`;
export const URL_DATA_INGESTION_MANUAL = `${hostDocs}/docs/tutorials/data-ingestion/ingesting-data`;

export const URL_POLICY = 'https://www.cognite.com/en/policy';
export const URL_ACADEMY = 'https://www.cognite.com/en/academy';

export const DEDICATED_GALACTICA_ID =
  process.env.REACT_APP_GALACTICA_PROJECT_ID || '';

export const PAGINATION_PAGE_SIZE = 20;
export const PAGINATION_MAX_SIZE = 1000;

export const PRIMARY_KEY_FDM = 'externalId';

export const COGNITE_API = 'https://api.cognitedata.com/api/v1';
